module.exports = __webpack_public_path__ + "media/images/crypto-currencies/ethereum-cf8aa5e7c7ee6fe226057d2329059293.svg";